// company-cart.js
(function () {
  // ---------- DOM helpers ----------
  const R   = () => document.querySelector('[data-company-drawer]');
  const P   = () => R() && R().querySelector('#pickup_location');
  const PE  = () => R() && R().querySelector('.pickup-error');
  const D   = () => R() && R().querySelector('#pickup_date');
  const DE  = () => R() && R().querySelector('.pickup-date-error');
  const B   = () => R() && R().querySelector('#company_purchase');
  const F   = () => R() && R().querySelector('.company-fields');
  const REQ = () => (R() ? Array.from(R().querySelectorAll('[data-required]')) : []);
  const CE  = () => R() && R().querySelector('.company-error');

  function save(attrs) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {
      // fail silently
    });
  }

  function checkoutButtons() {
    const d =
      document.querySelector('[id*="cart"].drawer, .cart-drawer, #CartDrawer') ||
      document;

    return Array.from(d.querySelectorAll('button, a')).filter(function (el) {
      const n = (el.getAttribute('name') || '').toLowerCase();
      const t = (
        (el.innerText || el.textContent || '') +
        ' ' +
        (el.value || '')
      ).toLowerCase();
      const h = (el.getAttribute('href') || '').toLowerCase();

      return (
        n === 'checkout' ||
        h.endsWith('/checkout') ||
        /checkout|apmaksa|pasūtījuma apmaksa/.test(t)
      );
    });
  }

  function disableCheckout(on) {
    checkoutButtons().forEach(function (b) {
      if (b.tagName === 'A') {
        if (on) {
          if (!b.dataset.href) {
            b.dataset.href = b.getAttribute('href') || '#';
          }
          b.setAttribute('href', 'javascript:void(0)');
        } else if (b.dataset.href) {
          b.setAttribute('href', b.dataset.href);
        }
      } else {
        b.disabled = !!on;
      }
      b.classList.toggle('is-disabled', !!on);
      b.setAttribute('aria-disabled', on ? 'true' : 'false');
      b.style.pointerEvents = on ? 'none' : '';
      b.style.opacity = on ? '0.7' : '';
    });
  }

  // ---------- validation ----------
  function validatePickup() {
    const p = P();
    if (!p) return true;

    const ok = !!p.value;
    const pe = PE();
    if (pe) pe.style.display = ok ? 'none' : '';
    p.classList.toggle('pickup-invalid', !ok);
    return ok;
  }

  function validateDate() {
    const d = D();
    if (!d) return true;

    let ok = !!d.value;

    // optional: disallow past dates
    if (ok) {
      try {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const chosen = new Date(d.value + 'T00:00:00');
        if (chosen < today) ok = false;
      } catch (e) {
        // if parsing fails, ignore extra check
      }
    }

    const de = DE();
    if (de) de.style.display = ok ? 'none' : '';
    d.classList.toggle('pickup-date-invalid', !ok);
    return ok;
  }

  function validateCompany() {
    const b = B();
    if (!b) return true;

    const error = CE();
    const requiredInputs = REQ();

    if (!b.checked) {
      if (error) error.style.display = 'none';
      requiredInputs.forEach(function (i) {
        i.classList.remove('company-invalid');
        i.removeAttribute('aria-invalid');
      });
      return true;
    }

    let ok = true;
    requiredInputs.forEach(function (i) {
      const empty = !(i.value || '').trim();
      i.classList.toggle('company-invalid', empty);
      i.setAttribute('aria-invalid', empty ? 'true' : 'false');
      if (empty) ok = false;
    });

    if (error) error.style.display = ok ? 'none' : '';
    return ok;
  }

  function validateAll() {
    const okPickup  = validatePickup();
    const okDate    = validateDate();
    const okCompany = validateCompany();
    const allow = okPickup && okDate && okCompany;

    disableCheckout(!allow);
    return allow;
  }

  // ---------- events ----------
  document.addEventListener('change', function (e) {
    if (!R()) return;

    // pickup location
    if (e.target === P()) {
      save({ pickup_location: P().value });
      validateAll();
      return;
    }

    // pickup date
    if (e.target === D()) {
      save({ pickup_date: D().value });
      validateAll();
      return;
    }

    // company checkbox
    if (e.target === B()) {
      const b = B();
      if (!b) return;

      const f = F();
      if (b.checked) {
        if (f) f.style.display = '';
        save({ company_purchase: 'yes' });
      } else {
        if (f) f.style.display = 'none';

        const attrs = {
          company_purchase: ''
        };

        REQ().forEach(function (i) {
          i.value = '';
          const key = i.name.replace('attributes[', '').replace(']', '');
          attrs[key] = '';
        });

        const vat = R().querySelector('input[name="attributes[company_vat]"]');
        if (vat) {
          vat.value = '';
          attrs.company_vat = '';
        }

        save(attrs);
      }

      validateAll();
    }
  });

  document.addEventListener('input', function (e) {
    if (!R()) return;
    if (!e.target.closest('[data-company-drawer]')) return;

    if (e.target.matches('[name^="attributes["]')) {
      const key = e.target.name.replace('attributes[', '').replace(']', '');
      const attrs = {};
      attrs[key] = e.target.value;
      save(attrs);

      // re-validate required fields
      if (e.target.hasAttribute('data-required') || e.target.id === 'pickup_date') {
        validateAll();
      }
    }
  });

  // Block checkout if invalid
  document.addEventListener(
    'click',
    function (e) {
      const t = e.target.closest('button, a');
      if (!t) return;
      if (checkoutButtons().indexOf(t) === -1) return;
      if (!validateAll()) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      const f = e.target.closest('form[action="/cart"]');
      if (!f) return;
      if (!validateAll()) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  // ---------- reset on load ----------
  function resetOnLoad() {
    if (!R()) return;

    if (P()) P().value = '';
    if (D()) D().value = '';
    if (B()) B().checked = false;
    if (F()) F().style.display = 'none';

    const attrs = {
      pickup_location: '',
      pickup_date: '',
      company_purchase: ''
    };

    REQ().forEach(function (i) {
      i.value = '';
      const key = i.name.replace('attributes[', '').replace(']', '');
      attrs[key] = '';
    });

    const vat = R().querySelector('input[name="attributes[company_vat]"]');
    if (vat) {
      vat.value = '';
      attrs.company_vat = '';
    }

    save(attrs);
    disableCheckout(true);
    validateAll();
  }

  // run once
  resetOnLoad();

  // if drawer re-renders, re-validate
  const d =
    document.querySelector('[id*="cart"].drawer, .cart-drawer, #CartDrawer') ||
    document.body;

  new MutationObserver(function () {
    validateAll();
  }).observe(d, { childList: true, subtree: true });
})();
